export const JOB_STATUS_UPDATE_REQUEST = 'job/status-update-request'
export const JOB_STATUS_UPDATE_SUCCESS = 'job/status-update-success'
export const JOB_STATUS_UPDATE_FAILED = 'job/status-update-failed'
